import React from 'react';

export const PageLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Reduced padding (px-3 py-4) for mobile, slightly larger for desktop */}
      <div className="max-w-5xl mx-auto px-3 py-4 md:px-6 md:py-8">
        {children}
      </div>
    </div>
  );
};

export const PageHeader = ({ title, description, action }) => {
  return (
    <div className="mb-4 md:mb-6 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
      <div>
        <h1 className="text-xl md:text-2xl font-semibold text-slate-900">{title}</h1>
        {description && <p className="mt-1 text-sm text-slate-500">{description}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
};